import React from "react";

const FeedItemPlaceholder = () => (
  <div className="FeedItem FeedItemPlaceholder">
    <div className="FeedItem__preview">
      <div className="FeedItem__preview__title">
        <div className="FeedItem__user" />
        <p />
        <p />
      </div>
    </div>
    <div className="FeedItem__preview">
      <p />
    </div>
    <div className="FeedItem__footer" />
  </div>
);

export default FeedItemPlaceholder;
